import { computed } from "vue";
import { useStoreItem } from "../itemStore.store";
import { resourceItemStructure, useResourceStore } from "./resources.store";
import { useSceneNodesStore } from "../scene/sceneNodes.store";
import { useSceneTree } from "../scene/sceneTree";
import type { SceneElementData } from "../sceneElement/SceneElementData";
import type { SceneNodeItem } from "../scene/SceneNodeItem";

export const useResource = useStoreItem(
  resourceItemStructure,
  useResourceStore,
  (resourceRef, _store) => {
    const treeNode = computed(() => {
      if (!resourceRef.value) return null;
      return useSceneTree().elementNodes.get(resourceRef.value.uid) ?? null;
    });
    const sceneNode = computed(() => {
      if (!treeNode.value) return null;
      return treeNode.value.node;
    });

    function updateNodeDataKey<K extends keyof SceneElementData>(key: K, value: SceneElementData[K]) {
      if (!treeNode.value) return;
      return useSceneNodesStore().updateDataKey<"element">(treeNode.value.id, key, value);
    }

    function updateNodeKey<K extends keyof SceneNodeItem>(key: K, value: SceneNodeItem[K]) {
      if (!treeNode.value) return;
      return useSceneNodesStore().updateKey(treeNode.value.id, key, value);
    }

    return {
      treeNode,
      sceneNode,
      updateNodeKey,
      updateNodeDataKey
    };
  }
);
